<div class="container-loading">
  <div class="container-icons">
    <object
      type="image/svg+xml"
      data="../../../../../assets/img/svg/plane-loader.svg"
    ></object>
  </div>
</div>
